import { render, staticRenderFns } from "./PowerFactor.vue?vue&type=template&id=11aa80ac&scoped=true&"
import script from "./PowerFactor.vue?vue&type=script&lang=js&"
export * from "./PowerFactor.vue?vue&type=script&lang=js&"
import style0 from "./PowerFactor.vue?vue&type=style&index=0&id=11aa80ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa80ac",
  null
  
)

export default component.exports